<div class="layout-container">
    <app-operations [isCollapsed]="isCollapsed"></app-operations>
    <div class="main-content">
        <app-top-bar (toggleSidebar)="handleToggle()"></app-top-bar>
        <div class="content-area" [userPermissionHandler]="viewPermissionHandlerData">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h5 class="fw-semibold">Other Charges</h5>
                <ejs-tooltip id="tooltipbtnNewOtherCharge" target="#targetNewOtherCharge" position="LeftCenter"
                    (beforeOpen)="onBeforeOpen($event)">
                    <button id="targetNewOtherCharge" class="btn btnAS" type="button"
                        (click)="openNewOtherChargeModal()" [userPermissionHandler]="createPermissionHandlerData">
                        NEW
                    </button>
                </ejs-tooltip>
            </div>
            <hr />
            <div class="container-fluid py-3">
                <div class="mb-3 d-flex align-items-center gap-3">
                    <div class="form-check">
                        <input class="form-check-input custom-radio" type="radio" name="status" id="all"
                            [checked]="activeTab === 'all'" (change)="applyFilter('all')" />
                        <label class="form-check-label" for="all">All</label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input custom-radio" type="radio" name="status" id="active"
                            [checked]="activeTab === 'active'" (change)="applyFilter('active')" />
                        <label class="form-check-label" for="active">Active</label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input custom-radio" type="radio" name="status" id="inactive"
                            [checked]="activeTab === 'inactive'" (change)="applyFilter('inactive')" />
                        <label class="form-check-label" for="inactive">Inactive</label>
                    </div>
                </div>

                <ejs-grid #gridOtherCharges [dataSource]="data" [allowFiltering]="true" [height]="250"
                    (created)="created($event)" (rowSelected)="onRowSelected($event)">
                    <e-columns>
                        <e-column field="Description" headerText="Items" width="170"></e-column>
                        <e-column field="RevenueCategory" headerText="Revenue Category" width="180"></e-column>
                        <e-column field="Recurring" headerText="Recurring" width="100" textAlign="Center">
                            <ng-template #template let-data>
                                <input type="checkbox" class="form-check-input" [checked]="data.Recurring" disabled />
                            </ng-template>
                        </e-column>
                        <e-column field="DailyCharge" headerText="Daily" width="100" textAlign="Right"
                            format="C2"></e-column>
                        <e-column field="WeeklyCharge" headerText="Weekly" width="100" textAlign="Right"
                            format="C2"></e-column>
                        <e-column field="MonthlyCharge" headerText="Monthly" width="100" textAlign="Right"
                            format="C2"></e-column>
                        <e-column field="InActive" headerText="Active / Inactive" width="130" textAlign="Center">
                            <ng-template #template let-data>
                                <span class="status-dot" [ngStyle]="{
                                    'background-color': data.InActive ? '#dc3545':'#28a745'
                                  }"></span>
                            </ng-template>
                        </e-column>
                        <e-column field="Priority" headerText="Priority" width="100" textAlign="Center"></e-column>
                        <e-column field="Delete" headerText="Delete" width="80" textAlign="Center">
                            <ng-template #template let-data>
                                <ejs-tooltip id="tooltipDeleteOtherCharge" target="#targetDeleteOtherCharge"
                                    position="TopCenter" (beforeOpen)="onBeforeOpen($event)">
                                    <div
                                        (click)="deleteOtherCharge(data.OtherRentalChargeId); $event.stopPropagation()">
                                        <a id="targetDeleteOtherCharge"
                                            [userPermissionHandler]="deletePermissionHandlerData">
                                            <img src="./assets/images/delete.svg" class="img-fluid" />
                                        </a>
                                    </div>
                                </ejs-tooltip>
                            </ng-template>
                        </e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </div>
    </div>
</div>

<!-- Modal -->
<div class="modal fade" id="otherChargesModal" tabindex="-1" aria-labelledby="otherChargesModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="otherChargesModalLabel">Other Charges</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body">
                <form [formGroup]="otherChargesForm">
                    <div class="row">
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label">Item<span class="text-danger">*</span></label>
                                <input type="text" class="form-control" formControlName="Description" maxlength="25" />
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="mb-3">
                                <label class="form-label">Revenue Category<span class="text-danger">*</span></label>
                                <select class="form-select" formControlName="OtherItemCategory">
                                    <option [ngValue]="null">-- Select Category --</option>
                                    <option *ngFor="let cat of otherItemCategories" [value]="cat.id">
                                        {{ cat.name }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="mb-3">
                                <label class="form-label">Daily</label>
                                <input type="text" class="form-control" formControlName="DailyCharge"
                                    appCurrencyFormatter value="$0.00" />
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="mb-3">
                                <label class="form-label">Weekly</label>
                                <input type="text" class="form-control" formControlName="WeeklyCharge"
                                    appCurrencyFormatter value="$0.00" />
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="mb-3">
                                <label class="form-label">Monthly</label>
                                <input type="text" class="form-control" formControlName="MonthlyCharge"
                                    appCurrencyFormatter value="$0.00" />
                            </div>
                        </div>

                        <div class="col-md-4">
                            <div class="mb-3">
                                <label class="form-label">Priority</label>
                                <input type="text" class="form-control" formControlName="Priority"
                                    (input)="allowOnlyDigits($event, 3)" />
                            </div>
                        </div>

                        <div class="col-md-4 d-flex">
                            <div class="mb-3">
                                <label class="form-label">Status</label>
                                <div class="d-flex gap-3 mt-2">
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" [value]="false"
                                            formControlName="InActive" />
                                        <label class="form-check-label">Active</label>
                                    </div>
                                    <div class="form-check">
                                        <input class="form-check-input" type="radio" [value]="true"
                                            formControlName="InActive" />
                                        <label class="form-check-label">Inactive</label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-4 d-flex align-items-center">
                            <div class="form-check mt-2">
                                <input class="form-check-input" type="checkbox" formControlName="Recurring" />
                                <label class="form-check-label">Recurring</label>
                            </div>
                        </div>
                    </div>
                </form>
            </div>

            <div class="modal-footer">
                <button type="button" class="btn btnAS" (click)="saveOtherCharge()" [disabled]="isSaveDisabled">
                    Save
                </button>
                <button type="button" class="btn btn-orange" (click)="cancelOtherCharge()">
                    Cancel
                </button>
            </div>
        </div>
    </div>
</div>